
export const GET_TERMINAL_SUCCESS = 'GET_TERMINAL_SUCCESS';



// WEBPACK FOOTER //
// ./app/terminals/constants/terminalsConstants.js